import { Card } from '@bpinternal/ui-kit-next'
import { DateTime } from 'luxon'
import { formatters } from '~/utils'
import type { KnowledgeSource, KnowledgeSourceType } from '../../types'
import { KnowledgeSourceIcon, KnowledgeSourceOrigin } from './KnowledgeSourceCell'

type KnowledgeSourceMobileCardProps = {
  knowledgeSource: KnowledgeSource
  onClick: () => void
  status: React.ReactNode
  showOrigin?: boolean
  additionalInfo?: React.ReactNode
}

export const KnowledgeSourceMobileCard = ({
  knowledgeSource,
  onClick,
  showOrigin = false,
  additionalInfo,
  status,
}: KnowledgeSourceMobileCardProps) => {
  const dsType = knowledgeSource.tags['dsType'] as KnowledgeSourceType
  const title = knowledgeSource.tags['title'] || knowledgeSource.key
  const faviconUrl = knowledgeSource.metadata?.['favicon']

  return (
    <Card className="cursor-pointer space-y-4 p-4 transition-colors hover:bg-muted/50" onClick={onClick}>
      <div className="flex items-center gap-3">
        {faviconUrl ? (
          <img src={faviconUrl} alt="Favicon" className="size-4" />
        ) : (
          <KnowledgeSourceIcon contentType={knowledgeSource.contentType} dsType={dsType} />
        )}
        <p className="truncate font-medium">{title}</p>
        {additionalInfo}
      </div>

      {showOrigin && (
        <div className="flex items-center gap-3 text-sm text-muted-foreground">
          <KnowledgeSourceOrigin dsType={dsType} />
          <span>{DateTime.fromISO(knowledgeSource.updatedAt).toRelative()}</span>
        </div>
      )}

      <div className="flex items-center justify-between">
        <span className="text-sm text-muted-foreground">{formatters.byte(knowledgeSource.size ?? 0)}</span>
        {status}
      </div>
    </Card>
  )
}
